import { render, staticRenderFns } from "./esta_seguienferme.vue?vue&type=template&id=00c28831"
import script from "./esta_seguienferme.vue?vue&type=script&lang=js"
export * from "./esta_seguienferme.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports